import { SearchUrlParamBuilder } from '@/core/utils'
import axios from 'axios'

const URL_PATH = 'api/permissionamento'

class PermissionamentoApiClient {
	async verificarPermissoesDoUsuarioNoOrgao(idOrgao, permissoes) {
		let URL = new SearchUrlParamBuilder({
			urlPath: `${URL_PATH}/verificarPermissoesDoUsuarioNoOrgao`,
			filters: { idOrgao: idOrgao, permissoes: permissoes },
		}).build()
		return await axios.get(URL)
	}
}

export default new PermissionamentoApiClient()
